<template>
  <button type="button" class="overview-action-button btn btn-block btn-lg" @click="onClicked" :disabled="disabled">
    <i :class="['far', 'fa-fw', icon, iconClass]" /><slot />
  </button>
</template>

<style scoped>
.overview-action-button {
  position: relative;
}
.overview-action-button > i {
  position: absolute;
  left: 10px;
  top: 11px;
}
</style>

<script>
export default {
  name: 'OverviewActionButton',
  props: {
    icon: String,
    iconClass: String,
    link: String,
    disabled: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    onClicked(evt) {
      // If no click listener, don't prevent default
      // If we have a link, push that instead of refreshing the page
      if(!this.$listeners || !this.$listeners.click) {
        if(this.link && this.link != '#') {
          evt.preventDefault()
          this.$router.push(this.link)
        }
        return
      }

      evt.preventDefault()
      this.$emit('click', evt)
    }
  }

}
</script>